import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
});

const TransactionSortObj = {
    first_name: { tableName: 'customers', sortColumn: 'first_name' },
    last_name: { tableName: 'customers', sortColumn: 'last_name' },
    store_name: { tableName: 'accounts', sortColumn: 'name' },
    box_name: { tableName: 'boxes', sortColumn: 'name' },
    phi_name: { tableName: '', sortColumn: 'member_number' },
    error_code: { tableName: '', sortColumn: 'id_number' },
    error_message: { tableName: '', sortColumn: 'smsphone' },
    rx_no: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
    fill_id: { tableName: '', sortColumn: 'fill_id' },
    prescription_id: { tableName: '', sortColumn: 'prescription_id' },
    was_updated: { tableName: '', sortColumn: 'was_updated' },
    pucode: { tableName: 'prescriptions_master', sortColumn: 'pucode' },
    created_on: { tableName: '', sortColumn: 'created_on' },
}

let TransactionFilterObj = {
    searchObject: null,
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 25,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowsPerPage: 25,
            loader: false,
            data: []
        };
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    onGridReady = (params) => {
        this.gridApi = params.api
        const datasource = this.getServerSideDatasource()
        // register datasource with the grid
        this.gridApi.setServerSideDatasource(datasource);
    }

    clearFilters = () => {
        const filterModel = this.gridApi.getFilterModel();
        if (Object.keys(filterModel).length > 0) {
            this.gridApi.setFilterModel(null);
            TransactionFilterObj.searchObject = null;
            TransactionFilterObj.fromdate = '';
            TransactionFilterObj.todate = '';
            this.gridApi.refreshServerSide();
        }
    };

    getServerSideDatasource = () => {
        const self = this;
        return {
            getRows(params) {
                TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

                const filterObject = params.request && params.request.filterModel
                const filterColumns = Object.keys(filterObject)

                // to set fromdate and todate
                if (filterObject.created_on) {
                    const dateValue = filterObject.created_on;
                    if (dateValue.operator) {
                        // for date range
                        if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
                            const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.fromdate = date1
                            TransactionFilterObj.todate = date2
                        }
                        if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
                            const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.fromdate = date1
                            TransactionFilterObj.todate = date2
                        }
                    } else {
                        // for from/to date
                        const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
                        if (dateValue.type === 'fromdate') {
                            TransactionFilterObj.fromdate = date
                            TransactionFilterObj.todate = ''
                        } else {
                            TransactionFilterObj.todate = date
                            TransactionFilterObj.fromdate = ''
                        }
                    }
                } else {
                    TransactionFilterObj.todate = '';
                    TransactionFilterObj.fromdate = ''
                }

                if (filterObject) {
                    if (filterColumns.length === 0) {
                        TransactionFilterObj.searchObject = null
                    } else {
                        TransactionFilterObj.searchObject = filterObject
                    }
                }

                if (params.request.sortModel.length > 0) {
                    TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
                    TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
                    TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
                }

                apiCall()

                function apiCall() {
                    self.setState({ loader: true });
                    fetch(process.env.REACT_APP_BASEURL + 'getPhiLogs', {
                        method: 'post',
                        withCredentials: true,
                        headers: {
                            Authorization:
                                'Bearer ' +
                                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                                    .jwtToken,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(TransactionFilterObj),
                    })
                        .then((httpResponse) => {
                            try {
                                return httpResponse.json();
                            } catch (error) {
                                return null;
                            }
                        })
                        .then((response) => {
                            if (response && response.results) {
                                if (response.results.length > 0) {
                                    params.successCallback(response.results, response.total);
                                    self.setState({ data: response.results })
                                } else {
                                    params.successCallback([], 0);
                                    self.setState({ data: [] })
                                }
                                self.setState({ loader: false })
                            }
                        })
                        .catch(error => {
                            self.setState({ loader: false })
                            console.error(error);
                            params.failCallback();
                        });
                }
            }
        };
    }

    DateCellFormatter = (params) => {
        return this.convertToTimeZone(params.value)
    }

    WasUpdatedCellRenderer = (params) => {
        return params.value === true || params.value === 'true' ? 'Yes' : 'No'
    }

    render() {
        const { classes, t } = this.props;
        const { data } = this.state;

        const columnDefs = [
            { field: "first_name", headerName: t("Report.phiLogs.FirstName"), },
            { field: "last_name", headerName: t("Report.phiLogs.LastName") },
            { field: "box_name", headerName: t("Report.phiLogs.Location") },
            { field: "store_name", headerName: t("Report.phiLogs.Store") },
            { field: "phi_name", headerName: t("Report.phiLogs.PhiName") },
            { field: "error_code", headerName: t("Report.phiLogs.ErrorCode") },
            { field: "error_message", headerName: t("Report.phiLogs.ErrorMessage") },
            { field: "rx_no", headerName: t("Report.phiLogs.RxNo") },
            { field: "fill_id", headerName: t("Report.phiLogs.FillID") },
            { field: "prescription_id", headerName: t("Report.phiLogs.PrescriptionId") },
            {
                field: "created_on", headerName: t("Report.phiLogs.CreatedOn"),
                cellRenderer: this.DateCellFormatter,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterOptions: [
                        {
                            displayKey: 'fromdate',
                            displayName: t('Report.phiLogs.FromDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                        {
                            displayKey: 'todate',
                            displayName: t('Report.phiLogs.ToDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                    ],
                    maxNumConditions: 2,
                },
            },
            { field: "was_updated", headerName: t("Report.phiLogs.WasUpdated"), filter: false, cellRenderer: this.WasUpdatedCellRenderer },
            { field: "pucode", headerName: t("Report.phiLogs.PUCode") },
        ];

        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <Box component="div">
                    <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
                        <Tooltip key="clear-filters" title={t("Report.phiLogs.ClearFiltersTooltip")}>
                            <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                                <CloseIcon style={{ color: "white" }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Box>
                <ReportsAGGrid
                    columnDefs={columnDefs}
                    sideBar={false}
                    suppressMenuHide={true}
                    rowData={data}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 150,
                        floatingFilter: true,
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            filterOptions: [{
                                displayKey: 'searchtext',
                                displayName: 'Search Text',
                                predicate: (cellValue) => cellValue
                            }],
                            maxNumConditions: 1,
                        },
                        resizable: true,
                        sortable: true,
                        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
                    }}
                    onGridReady={this.onGridReady}
                />
            </div>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/phi-logs/index.js